import { render, staticRenderFns } from "./yolcumnerede.vue?vue&type=template&id=1f4c27b3&scoped=true"
import script from "./yolcumnerede.vue?vue&type=script&lang=js"
export * from "./yolcumnerede.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4c27b3",
  null
  
)

export default component.exports